import { render, staticRenderFns } from "./importCYOrders.vue?vue&type=template&id=50c98cd2&scoped=true&"
import script from "./importCYOrders.vue?vue&type=script&lang=js&"
export * from "./importCYOrders.vue?vue&type=script&lang=js&"
import style0 from "./importCYOrders.vue?vue&type=style&index=0&id=50c98cd2&lang=less&scoped=true&"
import style1 from "./importCYOrders.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c98cd2",
  null
  
)

component.options.__file = "importCYOrders.vue"
export default component.exports